import PropTypes from 'prop-types'
import React from 'react'
import UserDto from '../../../administration/components/user/dto/UserDto'
import { nbPerPageLabel } from '../../../referencial/constants/ReferencialConstants'
import ProfileCard from '../../card/ProfileCard'
import { NewTable, WrapperAccordionDetails } from '../../datatable/NewTable'
import { Accordion, AccordionDetails, AccordionSummary, Grid } from '@mui/material'

const ProfileCardList = ({
    title,
    users,
    onClickTable,
    open,
}) => {
    return (
        <Accordion round defaultExpanded={open}>
            <AccordionSummary round>{title}</AccordionSummary>
            <AccordionDetails sx={{ padding: users.length <= 25 ? 1 : 0 }}>
                {users.length <= 25 ? (
                    <>
                        {!!users?.length && (
                            <Grid container spacing={1}>
                                {users.map((card, i) => (
                                    <Grid size={2} key={i} container alignItems='stretch'>
                                        <ProfileCard
                                            picture={card.picture}
                                            onClick={card.onClick}
                                        >
                                            {card.content}
                                        </ProfileCard>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </>
                ) : (
                    <NewTable
                        headers={['login', 'name', 'mail', 'mobile', 'tel', 'admin', 'metadata', 'organism', 'townName', 'lastConnexion']}
                        rows={users}
                        rowsPerPageOptions={nbPerPageLabel}
                        onClickRow={(user) => onClickTable(user.login)}
                        WrapperComponent={WrapperAccordionDetails}
                    />
                )}
            </AccordionDetails>
        </Accordion>
    )
}

ProfileCardList.propTypes = {
    title: PropTypes.string.isRequired,
    users: PropTypes.arrayOf(PropTypes.instanceOf(UserDto)),
    onClickTable: PropTypes.func,
    open: PropTypes.bool,
}
export default ProfileCardList
